import {
	UPDATE_PRODUCT_COMPONENTS,
	UPDATE_SELECTED_PRODUCT,
	UPDATE_PRODUCT_PARAMS,
	UPDATE_UNITS_OF_PRICE,
	SHOW_ERROR_MESSAGE
} from '../actionTypes';

const initialState = {
	product: {},
	seller: {},
	productComponents: {},
	orderProducts: {},
	orderSubtotal: 0,
	categoriesObject: {},
	availableProducts: [],
	searchParams: {
		dateRange: {
			startDate: null,
			endDate: null,
		}
	},
	qty: {},
	unitOfPrice: null,
	subtotal: {},
	selected: {},
	unitsOfPrice: {},
	showProductUnavailableForDatesError: false,
	showMaxQuantityErrorMsg: false,
	showMinQuantityErrorMsg: false,
	availableIntervals: [],
};

export default function (state = initialState, action) {
	switch (action.type) {
	case UPDATE_SELECTED_PRODUCT: {
		const { product } = action.payload;
		return {
			...state,
			product,
		};
	}
	case UPDATE_PRODUCT_COMPONENTS: {
		const { productComponents } = action.payload;
		return {
			...state,
			productComponents,
		};
	}
	case UPDATE_PRODUCT_PARAMS: {
		const { productParams } = action.payload;
		return {
			...state,
			...productParams,
		};
	}
	case UPDATE_UNITS_OF_PRICE: {
		const { unitsOfPrice } = action.payload;
		return {
			...state,
			unitsOfPrice: {
				...state.unitsOfPrice,
				...unitsOfPrice,
			}
		};
	}
	case SHOW_ERROR_MESSAGE: {
		const { flag } = action.payload;
		return {
			...state,
			...flag
		};
	}
	default:
		return state;
	}
}
